import { useState, useEffect, createRef } from "react";
import { Link as RouterLink } from "react-router-dom";
import { useForm, Controller  } from "react-hook-form";
import { useGetUserQuery } from "context/users/usersApiSlice";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "context/auth/authSlice";

import useHelper from "hooks/useHelper";
import useGeolocation, {CountrySelect, ProvincesSelect} from "hooks/useGeolocation";

import MDInput from "dashboard/components/MDInput";
import MDAlert from "dashboard/components/MDAlert";
import MDBox from "dashboard/components/MDBox";
import MDButton from "dashboard/components/MDButton";
import MDTypography from "dashboard/components/MDTypography";
import { CircularProgress, Grid, Icon, LinearProgress, Link  } from "@mui/material";
import DatePickers from "dashboard/examples/Forms/CostumFormFields/DatePickers";
import { BasicSelect, JobsSelect } from "dashboard/examples/Forms/CostumFormFields/SelectMutipple";


const Index  = ({ action,phase = null, isCommandeLoading, isCommandeSuccess, setConnectedUser = null}) => {
    // const buttonGroup = createRef();
    const { isValidEmail, isValidName, isValidPhone, autoSpacing, isNotEmpty,isValidAdress } = useHelper();
    const [errorMsg, setErrorMsg] = useState("");
    const { getGeoLocationData, coordinates, getAlgerianProvince } = useGeolocation(); 
    const [geolocation, setGeolocation] = useState({latlng:{},geoLocate:{}});
    const id = useSelector(selectCurrentUser)?.id;

    const {
        data: profile,
        isSuccess,
        isLoading,
        isError,
        error
    } = useGetUserQuery(id, {
            // pollingInterval: 60000,
            refetchOnMountOrArgChange: true
    });
    
    /*eslint-disable*/
    

    const initialValues = {
        displayName:'',
        birthdate:'',
        email:'',
        phone : '',
        gender: '',
        location:{
            country : {},
            street : "",
            state : {},
            coordinates : {
                lat :'',
                lng :''
            }
        },
        social : {
            fb:'',
            insta : '',
            ytube:'',
            tweet : ''
        },
        job :'',
        about:'',
        payement : "cash"
    }
    const { register, handleSubmit, setValue, control, reset, formState: { errors } } = useForm({
        /* eslint-disable */
        defaultValues: profile ? {...profile, payement : "cash"} : initialValues
    });

    // setup login error messages
    const loginState = {
        displayName:'Lastname Firstname and a space between',
        email:'a valid email adress is required',
        phone:'Please respect this pattern +213 0123 456 789',
        birthdate :"Please enter your birthdate",
        address :"Please enter a correct street address",
        country :"Please chose your country",
        state : "Please chose your province",
        gender:"Select your gender please",
        job : "Please select a value for your job from the list",
        payement : "Please chose a payement method"
    };

    useEffect( async () => {
        isError ? setErrorMsg(error.data?.error) : null;  
    },[isError,]);

    // load geolocation data
    useEffect( async () => {
        isSuccess && profile ?  reset(profile) : null;
        let userLocation = { 
            country: profile?.location?.country ,
            state  : profile?.location?.state,
            countryCode : profile?.location?.country?.code,
            coordinates : profile?.location?.coordinates
        } 

        if(!userLocation.country || !userLocation.state){
            const getUserGeolocation = await getGeoLocationData("fr");
            userLocation = { 
                ...userLocation,
                country: profile?.location?.country ? profile?.location?.country : getUserGeolocation.country,
                countryCode : profile?.location?.country?.code ? profile?.location.country?.code : getUserGeolocation.countryCode,
                state  : profile?.location?.state ? profile?.location.state : {
                    "province" : getUserGeolocation?.regionName,
                    "code" : getUserGeolocation?.region
                } 
            } 
        }
        if(!userLocation.coordinates){
            userLocation = { 
                ...userLocation,
                coordinates : await coordinates()
            }
        }
        setGeolocation({
            latlng    : userLocation.coordinates,
            geoLocate : userLocation,
        });
        setValue("location.state",userLocation.state)
        setConnectedUser && setConnectedUser({latlng : userLocation.coordinates})
        setErrorMsg("")
    }, [profile]);

    const onSubmit = async data =>{
        data.location.coordinates = geolocation.latlng;
        if(phase ===  'UserInfos'){ 
            data.payement = "cash";
            const { photos,birthdate, about, createdAt, gender, isCouriers, job, provider, role, social, updatedAt,...rest } = data;
             await action(rest);    
        }else{ 
            const { photos,payement, ...rest } = data;
            action(rest)
        }
        
    }
  return (
    <MDBox component="form" sx={{ whiteSpace: "normal" }} role="form" onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="on">
        {isLoading  && <LinearProgress color="info"   sx={{ marginBottom:"15px", width:"100%", overflowX:"hidden"}} />}   
        <Grid container  spacing={{ xs: 1, md: 2 }} >
            {phase ===  'UserInfos' && <Grid xs={12} item>
                <MDBox display="flex"  justifyContent="space-between">
                <MDTypography sx={{display:"inline-flex"}} variant="h6" color="text">Contact information</MDTypography>
                {!profile && <MDTypography sx={{display:"inline-flex"}} variant="body2">Already have an account? <Link color="info.light" sx={{ml:1,  transition :"all ease-in-out .5s", '&:hover':{
                    color : ({palette}) => palette.info.dark,
                    fontWeight : 500,
                }}} underline="none" component={RouterLink} to='/authentication/sign-in'>login</Link></MDTypography>}
                </MDBox>
            </Grid>}
            <Grid xs={12} lg={6} item>
                <MDBox mb={1}>
                    <Controller name="displayName" control={control} 
                        render={({ field: { onChange, value } }) => (
                        <MDInput   onChange={onChange}   value={value} type="text" label="Fullname" required fullWidth 
                        {...register("displayName", { required: loginState.displayName, validate: isValidName})}
                        error={Boolean(errors.displayName)}
                        helperText={errors.displayName?.message}
                        size="medium"
                        />
                        )}
                    />
                </MDBox>
            </Grid>
            <Grid xs={12} lg={6}  item>      
                <MDBox mb={1}>
                    <Controller name="email" control={control} 
                        render={({ field: { onChange, value } }) => (
                        <MDInput   onChange={onChange}   value={value} type="email" label="Email" required fullWidth 
                        {...register("email", { required: phase !==  'UserInfos' ?  loginState.email : false, validate: phase !==  'UserInfos' ? isValidEmail : value === ""  })}
                        error={Boolean(errors.email)}
                        helperText={errors.email?.message} 
                        size="medium"
                        />
                        )}    
                    />
                </MDBox>
            </Grid>
            <Grid xs={12} lg={6} item>
                <MDBox mb={1}>
                    <Controller name="phone" control={control} 
                        render={({ field: { onChange, value } }) => (
                        <MDInput   onChange={onChange} value={value || ''} type="tel" label="Phone" required fullWidth 
                            {...register("phone", { required: loginState.phone,validate : isValidPhone })}
                            error={Boolean(errors.phone)}
                            helperText={errors.phone?.message} 
                            onKeyUp={e=>autoSpacing(e,onChange)}
                            autoComplete="off"
                            size="medium"
                            placeholder="+213 0123 456 789"
                            />
                        )}
                    />
                </MDBox>
            </Grid>
            {phase ===  'UserInfos' ? (<></>
            ) : (
                <><Grid xs={12} lg={6} item>
                  <MDBox mb={1}>
                      <Controller
                          name="birthdate"
                          control={control}
                          defaultValue={null}
                          rules={{ required: loginState.birthdate, validate: isNotEmpty }}
                          render={({ field: { onChange, value } }) => (
                              <DatePickers
                                  key={errors.birthdate}
                                  value={value}
                                  onChange={onChange}
                                  type="single"
                                  id="hf-picker"
                                  helperText={errors.birthdate?.message}
                                  error={Boolean(errors.birthdate)} />
                          )} />
                  </MDBox>
              </Grid><Grid xs={12} lg={6} item>
                      <MDBox mb={1}>
                          <Controller
                              name="gender"
                              control={control}
                              rules={{ required: loginState.gender, validate: value => !Boolean(isNaN(value)) }}
                              render={({ field: { onChange, value } }) => (
                                  <BasicSelect
                                    size="medium"
                                    options={[{name : "mâle"},{name : "femelle"}]}
                                    selected={profile?.gender}
                                    value={value}
                                    label="genre"
                                    onChange={onChange}
                                    helperText={errors.gender?.message}
                                    error={Boolean(errors.gender)} />
                              )} />
                          {Boolean(errors.gender) && <p className="MuiFormHelperText-root MuiFormHelperText-sizeMedium MuiFormHelperText-contained Mui-required css-yi5zz-MuiFormHelperText-root">{loginState.gender}</p>}
                      </MDBox>
                  </Grid>
                  <Grid xs={12} lg={6} item>
                      <MDBox mb={1}>
                          <JobsSelect
                              selected={profile?.job}
                              register={register}
                              control={control} />
                          {Boolean(errors.job) && <p className="MuiFormHelperText-root MuiFormHelperText-sizeMedium MuiFormHelperText-contained Mui-required css-yi5zz-MuiFormHelperText-root">{loginState.job}</p>}
                      </MDBox>
                  </Grid></>
                  )}
            <Grid xs={12} md={7} item>
                <MDBox mb={1}>
                    <Controller name="location.street" control={control} 
                        render={({ field: { onChange, value } }) => (
                        <MDInput   onChange={onChange} value={value} type="text" label="address" required fullWidth 
                            {...register("location.street", { required: loginState.address,validate : isValidAdress })}
                            error={Boolean(errors.location?.street)}
                            helperText={errors.location?.street?.message} 
                            autoComplete="off"
                            size="medium"
                            multiline rows={4}
                            placeholder="123, boulevard des martyres Bloc 5"
                            />
                        )}
                    />
                </MDBox>
            </Grid>
            <Grid xs={12} md={5} item>
                <MDBox mb={1}>
                    <MDBox mb={1}>
                    <CountrySelect 
                        register={register}
                        control={control}
                        setinitvalue={setValue}
                        selected={geolocation.geoLocate?.countryCode}
                    />
                    {Boolean(errors.location?.country) && <p className="MuiFormHelperText-root MuiFormHelperText-sizeMedium MuiFormHelperText-contained Mui-required css-yi5zz-MuiFormHelperText-root">{loginState.country}</p>}
                    </MDBox>
                    <ProvincesSelect province={getAlgerianProvince} 
                        selected={geolocation.geoLocate?.state} 
                        register={register}
                        control={control}
                    />
                    {Boolean(errors.location?.state) && <p className="MuiFormHelperText-root MuiFormHelperText-sizeMedium MuiFormHelperText-contained Mui-required css-yi5zz-MuiFormHelperText-root">{loginState.state}</p>}
                </MDBox>
            </Grid>
        </Grid>
        <MDBox mt={5} mb={1}>
            {errorMsg  && <MDAlert color="error"><small style={{ fontSize:"12px",whiteSpace: "normal" }}> {errorMsg} </small></MDAlert> }
        </MDBox>
        {phase ===  'UserInfos' &&  <MDBox sx={{display:"flex", alignItems:"center"}}><Icon sx={{mx:1}} color="info">info</Icon><MDTypography fontWeight="medium" variant="caption" color="secondary" >
                Veuillez choisir un distributeur dans la liste ci-dessous avant de passer votre commande.
            </MDTypography></MDBox>}
        <MDBox mt={1} mb={1} mr={2} display="flex" justifyContent="space-between" alignItems="center"  >
           
            {phase ===  'UserInfos' && <MDTypography sx={{display:"inline-flex"}} variant="body2"><Link color="info.light" sx={{ml:1,transition :"all ease-in-out .5s", '&:hover':{
                    color : "info.dark",
                    fontWeight : 500,
            }}} underline="none" component={RouterLink} to='/Checkout/ShoppingCart'><Icon>arrow_back_ios</Icon> Panier</Link></MDTypography>}
            <MDButton disabled={isCommandeLoading} size="medium" px={{xs:.5, lg:2}}  variant="gradient" color="info" type="submit" >
                {isCommandeLoading ? <CircularProgress size="1rem" color="white" /> :<Icon fontSize="medium">save</Icon>}
                <span style={{margin : "0 5px"}}>{phase ===  'UserInfos' ? "passer la commande" : "valider"}</span>
            </MDButton>
        </MDBox>
    </MDBox>
  )
}

export default Index